import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_QUANLYTHUCHIHOPDONG } from "../actions/QuanLyThuChiHopDong/actionTypes";
import {
  getListQuanLyThuChiHopDongSuccess,
  getListQuanLyThuChiHopDongFailure,
} from "../actions/QuanLyThuChiHopDong";
import { pushNotification } from "utils/notifications";
import QuanLyThuChiHopDongApi from "../service/quanLyThuChiHopDongApi";

function* getListQuanLyThuChiHopDong(action) {
  try {
    const response = yield call(QuanLyThuChiHopDongApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListQuanLyThuChiHopDongSuccess(response.data));
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(getListQuanLyThuChiHopDongFailure());
    }
  } catch (error) {
    pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
    yield put(getListQuanLyThuChiHopDongFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_QUANLYTHUCHIHOPDONG, getListQuanLyThuChiHopDong);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
